<template>
  <el-dialog :visible.sync="dialogVisible" title="Random Selections" v-bind="randomSelections">
    <div v-if="loadingRandomSelections" class="loader">
      <loader message="Loading random selections" />
    </div>

    <empty v-if="!loadingRandomSelections && randomSelections.length === 0">
      <p class="description">There are No winner selections at the moment</p>
      <br />
    </empty>

    <el-card
      v-if="!loadingRandomSelections"
      shadow="hover"
      class="box-card"
      v-for="randomSelection in randomSelections"
      v-bind:key="randomSelection.id"
      style="margin-bottom:10px"
    >
      <div class="row">
        <div class="col-lg-12">
          <span
            class="text-muted"
          >{{ formateDate(randomSelection.from_date) }} - {{ formateDate(randomSelection.to_date) }}</span>
        </div>
        <div class="col-lg-6">
          <dl class="dl-horizontal">
            <dt>Created by:</dt>
            <dd>
              <span class="word-wrap">{{ randomSelection.created_by_name }}</span>
            </dd>
          </dl>
        </div>
        <div class="col-lg-6">
          <dl class="dl-horizontal">
            <dt>Winners:</dt>
            <dd>
              <span>{{ randomSelection.winners }}</span>
            </dd>
            <dt>Status:</dt>
            <dd>
              <span
                class="label label-success"
                v-if="randomSelection.status_display === 'Complete'"
              >Complete</span>
              <span class="label label-info" v-if="randomSelection.status_display === 'New'">New</span>
              <span
                class="label label-warning"
                v-if="randomSelection.status_display === 'Processing'"
              >Processing</span>
            </dd>
          </dl>
        </div>
        <div class="col-lg-12" v-if="randomSelection.selections.length > 0">
          <el-collapse accordion @change="handleChange">
            <el-collapse-item name="showSelections">
              <template slot="title">
                <a>{{ collapeseTite }}</a>
              </template>
              <el-table :data="randomSelection.selections">
                <el-table-column type="index" label="#" width="60" />
                <el-table-column label="Originator" sortable prop="originator" />
                <el-table-column label="Date won" sortable prop="originator">
                  <template slot-scope="scope">{{scope.row.won_date}}</template>
                </el-table-column>
                <el-table-column label="Action">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      @click="onSelectWinner(scope.row)"
                      :disabled="isDisqualified(scope.row.won_date)"
                      size="small"
                    >
                      <i
                        class="fa fa-spinner fa-spin"
                        v-show="settingRandomSelectionWinner && scope.row === selectedWinner"
                      ></i>
                      Win
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-card>
  </el-dialog>
</template>

<script>
/* eslint no-param-reassign: "off" */

import { mapState } from 'vuex';
import moment from 'moment';
import Loader from '@/components/common/Loader';
import Empty from '@/components/common/Empty';

export default {
  name: 'RandomSelectionsDialog',
  components: { Loader, Empty },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    campaignId: {
      type: Number,
      requied: true,
    },
  },
  data: () => ({
    selectedWinner: null,
    collapeseTite: 'Show selections',
  }),
  computed: {
    dialogVisible: {
      get() {
        this.$store.dispatch('campaign/getRandomSelections', this.campaignId);
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
    ...mapState('campaign', [
      'randomSelections',
      'loadingRandomSelections',
      'settingRandomSelectionWinner',
    ]),
  },
  methods: {
    formateDate(date) {
      return moment(String(date)).format('ddd Do MMMM YYYY');
    },

    formatRowDate(row, column, cellValue) {
      return this.formatDate(cellValue);
    },

    onSelectWinner(selection) {
      this.selectedWinner = selection;
      this.$store.dispatch('campaign/getRandomSelectionsWinner', selection);
      // this.$forceUpdate();
    },
    handleChange(val) {
      this.collapeseTite = val === 'showSelections' ? 'Hide selections' : 'Show selections';
    },
    isDisqualified(date) {
      const dateWon = date;
      const now = moment();
      const dif = now.diff(dateWon, 'days');
      return dif <= 90;
    },
  },
};
</script>

<style lang="scss" scoped>
.more-btn {
  float: right;
  background-color: transparent;
  border: none;
  margin-right: 0.5rem;
  i {
    margin-left: 1rem;
  }
}

i.el-collapse-item__arrow {
  float: right;
  margin: 0 0.5rem;
  width: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// RandomSelectionsDialog.vue?15cd8a83